import { render } from "./SideBarLeft.vue?vue&type=template&id=0050aa98"
import script from "./SideBarLeft.vue?vue&type=script&lang=js"
export * from "./SideBarLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__